import React from "react";

const GradientText = ({ text = "NEW FEATURE", className = "" }) => {
  return (
    <span
      className={`inline-block text-sm font-extrabold bg-gradient-to-r from-[#0079E9] to-[#00BCC4] bg-clip-text text-transparent ${className}`}
    >
      {text}
    </span>
  );
};

export default GradientText;
